import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApplicationInsightsService } from '@app/core/services/application-insights/application-insights.service';

@Injectable()
export class AppInsightsInterceptor implements HttpInterceptor {
  constructor(private applicationInsightsService: ApplicationInsightsService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.applicationInsightsService.logEvent(req.url, { body: req.body });
    return next.handle(req);
  }
}
